// 登录后强制绑 2FA 守卫（Admin 本波不强制改密）
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { fetchMe } from '@/api/auth';
import { loadSession, saveSession, SESSION_CHANGED_EVENT } from '@/api/client';

/** 现网 App.tsx：platform/system/security → pages/system/Security */
const MFA_PATH = '/platform/system/security';

function isMfaPath(pathname: string): boolean {
  return pathname.includes('system/security') || pathname === '/security';
}

/** 订阅 session 写入，供布局/安全页在改密或绑 2FA 后重读标志 */
export function useSetupFlags() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(SESSION_CHANGED_EVENT, bump);
    return () => window.removeEventListener(SESSION_CHANGED_EVENT, bump);
  }, []);
  const me = loadSession()?.me;
  return {
    mustChangePassword: me?.mustChangePassword === true,
    mfaSetupRequired: me?.mfaSetupRequired === true,
  };
}

export default function RequireSetup() {
  const location = useLocation();
  const { mfaSetupRequired } = useSetupFlags();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void fetchMe().then((res) => {
      if (cancelled) {
        return;
      }
      if (res.ok) {
        const s = loadSession();
        if (s) {
          saveSession({ ...s, me: res.data });
        }
      }
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return <div className="p-10 text-center text-sm text-slate-400">加载会话…</div>;
  }
  if (mfaSetupRequired && !isMfaPath(location.pathname)) {
    return <Navigate to={MFA_PATH} replace={true} />;
  }
  return <Outlet />;
}
